<template>
  <div class="newdetail_wrap article-detail-page">
    <div class="red_top_bg article-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ data.title }}
      </div>
    </div>
    <div class="ctn article-content">
      <!-- <vue-editor v-model="data.content" style="display: none"/> -->
      <div
        class="contract_box article-body"
        v-html="data.content"
      />
      <time class="article-time">
        2019-03-21 02:50:35
      </time>
    </div>
  </div>
</template>

<script>

    import Fetch from "../../utils/fetch";

    export default {
        name: "Aritcle",
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/article_detail', {
                    id: this.$router.history.current.params.code
                }).then(res => {
                    this.data = res.data;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
.article-detail-page {
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
    color: #000;
    box-sizing: border-box;
}

.article-top {
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 10;
    height: 50px;
    background: #fff;
    border-bottom: 1px solid #e8e9ee;
    transform: translateX(-50%);
    box-sizing: border-box;

    .big_tit {
        max-width: 72%;
        height: 50px;
        top: 0;
        color: #000;
        font-size: 18px;
        font-weight: 700;
        line-height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: normal;
    }
}

.article-content {
    width: 100%;
    min-height: 100vh;
    margin: 50px auto 0;
    padding: 10px 8px 0;
    background: #fff;
    box-sizing: border-box;
}

.article-body {
    width: 100%;
    color: #6d7688;
    font-size: 14px;
    font-weight: 700;
    line-height: 27px;
    word-break: break-word;
    box-sizing: border-box;

    /deep/ * {
        max-width: 100%;
        font-size: inherit !important;
        line-height: inherit !important;
        color: inherit !important;
        background: transparent !important;
        box-sizing: border-box;
    }

    /deep/ p,
    /deep/ div {
        margin: 0;
    }

    /deep/ p + p,
    /deep/ div + div {
        margin-top: 12px;
    }

    /deep/ img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 10px auto;
    }
}

.article-time {
    display: block;
    margin: 48px 8px 0 0;
    color: #555d6b;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: right;
    word-break: break-word;
}

@media screen and (max-width: 374px) {
    .article-body {
        font-size: 19px;
        line-height: 26px;
    }

    .article-time {
        font-size: 15px;
        line-height: 21px;
    }
}
.article-detail-page {
    min-height: 100vh;
    padding-bottom: calc(84px + env(safe-area-inset-bottom));
    background: #201c1d;
    color: #f4ece7;
}

.article-top {
    background: #201c1d;
    border-bottom-color: #302723;
}

.article-top .back_left {
    opacity: 1;
    filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
}

.article-top .big_tit {
    color: #f3c99e;
}

.article-content {
    min-height: calc(100vh - 50px);
    margin-top: 50px;
    padding: 12px 10px 24px;
    background: #201c1d;
}

.article-body {
    padding: 16px 14px 18px;
    border: 1px solid #75654f;
    border-radius: 9px;
    background: linear-gradient(110deg, #232323, #303030);
    color: #e7dbd1;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.24);
}

.article-body /deep/ a {
    color: #f3c99e !important;
}

.article-body /deep/ img {
    border-radius: 7px;
}

.article-body /deep/ td,
.article-body /deep/ th {
    border-color: #75654f;
}

.article-time {
    margin: 14px 4px 0 0;
    color: #bda895;
    font-size: 12px;
    line-height: 18px;
}

@media screen and (max-width: 374px) {
    .article-content {
        padding-right: 8px;
        padding-left: 8px;
    }

    .article-body {
        padding-right: 12px;
        padding-left: 12px;
        font-size: 14px;
        line-height: 24px;
    }

    .article-time {
        font-size: 12px;
        line-height: 18px;
    }
}
</style>
